export function getDomain() {
  return window.location.hostname.match(/\.([a-z]{2,})$/);
}

export function getLocale(defaultValue) {
  const domainMatch = getDomain();
  if (!domainMatch) {
    return defaultValue;
  }
  if (domainMatch[1] === 'com') {
    return 'en';
  }
  return domainMatch[1];
}

export function changeLocale(value) {
  let { href } = window.location;
  let enGroups = [];
  switch (value) {
    case 'ru':
    /**
      * https://master.stage.kiwitaxi.com/en/client/login
      * Group 1. `.com/en/`
      * Group 2. `en`
    */
      enGroups = href.match(/(.com\/([A-Za-z]{1,})\/)client\/?/);
      href = href.replace(enGroups[1], '.ru/');
      break;
    default:
      href = href.replace('.ru', '.com');
  }
  window.location.replace(href);
}

export default getLocale;



// WEBPACK FOOTER //
// ./src/assets/js/utils/browser.js